import Route from '@ember/routing/route';

export default class ApplicationRoute extends Route {
  // Locale is now handled by the locale route and instance initializer
  // This route is kept minimal as a shell for child routes
}

